import React from 'react';

import AlertPagesDatatable, {
	type AlertPagesDatatableIncident,
	type AlertPagesDatatableRef,
} from '~/components/logic/alertPages/AlertPagesDatatable';



type Props = {
	incident: AlertPagesDatatableIncident,
	scrollCallback: () => void,
};

const PagePropertyChangedDatatable = React.forwardRef<AlertPagesDatatableRef, Props>((props, ref) => {
	const {
		incident,
		scrollCallback,
	} = props;

	const incidentProperty = incident.get('settings').get('property');

	const extraColumns = React.useMemo(
		() => {
			return [
				incidentProperty,
			];
		},
		[
			incidentProperty,
		],
	);

	return (
		<AlertPagesDatatable
			extraColumns={extraColumns}
			incident={incident}
			ref={ref}
			scrollCallback={scrollCallback}
			showImportance={true}
		/>
	);
});



export default PagePropertyChangedDatatable;
